import { useEffect } from 'react';
import { useResourcesConfig } from '../config/ResourcesConfigContext';

/**
 * Sets the browser-tab title for a shared resource page. No-ops when the host
 * app did not configure a suffix, so the dashboard (which does not manage tab
 * titles) is unaffected while files-viewer keeps its `… · ODO Admin` format.
 *
 * Pass null while a dynamic title is still loading — the previous title sticks.
 */
export function useResourcePageTitle(title: string | null | undefined): void {
    const { documentTitleSuffix } = useResourcesConfig();
    useEffect(() => {
        if (!documentTitleSuffix || !title) return;
        document.title = `${title} · ${documentTitleSuffix}`;
    }, [title, documentTitleSuffix]);
}
